import React from 'react';
import PropTypes from 'prop-types';
import { connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { bindToContent, CmsEntities } from 'client/data/models/cms';
import { featureFlags } from 'client/utils/feature-flags';
import { getSubtypeContentPath } from 'site-modules/shared/utils/upper-funnel/content-path';
import { getIsSeot4733 } from 'client/utils/seot-4733';
import { SubtypePage, SubtypePageSeo } from './subtype';

function SubtypeRendererUI({ content, type, subtype }) {
  if (!content) {
    return null;
  }

  const seot4733Level2SubtypePagesFF = featureFlags.get('seot-4733-level-2-subtype-pages');
  const isSeot4733 = getIsSeot4733(seot4733Level2SubtypePagesFF, type, subtype);
  return isSeot4733 ? (
    <SubtypePageSeo content={content} type={type} subtype={subtype} />
  ) : (
    <SubtypePage content={content} type={type} subtype={subtype} />
  );
}

SubtypeRendererUI.propTypes = {
  content: CmsEntities.Content,
  type: PropTypes.string,
  subtype: PropTypes.string,
};

SubtypeRendererUI.defaultProps = {
  content: null,
  type: null,
  subtype: null,
};

export const stateToPropsConfig = {
  content: bindToContent(({ type, subtype }) => getSubtypeContentPath(type, subtype)),
};

export const SubtypeRenderer = connectToModel(SubtypeRendererUI, stateToPropsConfig);
